import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Star, ArrowRight, X } from 'lucide-react';
import '../../../assets/styles/customer/layout/TestimonialsSection.css';

const TestimonialsSection = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(null);

  const testimonials = [
    {
      id: 1,
      initials: 'AK',
      name: 'Ahmed Khan',
      username: '@ahmed',
      headline: 'Transformed my business completely!',
      rating: 5,
      date: 'Dec 15, 2024',
      story: 'MilkFlow has completely revolutionized how I manage my dairy business. The QR code system saves me hours every day, and my customers love the transparency. Monthly billing is now automated and error-free!',
      bgColor: '#e3f2fd',
      position: { top: '15%', left: '8%' }
    },
    {
      id: 2,
      initials: 'FB',
      name: 'Fatima Butt',
      username: '@fatima',
      headline: 'Transparent billing at its best!',
      rating: 5,
      date: 'Dec 18, 2024',
      story: 'As a customer, I finally have complete visibility of my daily milk deliveries. No more disputes or confusion. The mobile app makes it super easy to track everything in real-time.',
      bgColor: '#e8f5e9',
      position: { top: '10%', right: '12%' }
    },
    {
      id: 3,
      initials: 'MR',
      name: 'Muhammad Raza',
      username: '@muhammad',
      headline: '40% business growth achieved!',
      rating: 5,
      date: 'Dec 10, 2024',
      story: 'Since implementing MilkFlow, my customer base has grown by 40%! The professional system has built trust with customers, and the automated invoicing has reduced payment delays significantly.',
      bgColor: '#fff3e0',
      position: { top: '55%', right: '8%' }
    },
    {
      id: 4,
      initials: 'SA',
      name: 'Sara Ali',
      username: '@sara',
      headline: 'Perfect for busy families!',
      rating: 5,
      date: 'Dec 20, 2024',
      story: 'Managing milk delivery was always a hassle with my busy schedule. MilkFlow sends me real-time notifications, and I can see exactly what I owe at month-end. Highly recommended!',
      bgColor: '#fce4ec',
      position: { top: '45%', left: '15%' }
    },
    {
      id: 5,
      initials: 'UA',
      name: 'Usman Ahmad',
      username: '@usman',
      headline: '30% cost reduction!',
      rating: 5,
      date: 'Dec 12, 2024',
      story: 'The analytics dashboard helped me identify inefficiencies in my distribution routes. I reduced operational costs by 30% and increased customer satisfaction at the same time.',
      bgColor: '#f3e5f5',
      position: { bottom: '25%', right: '18%' }
    },
    {
      id: 6,
      initials: 'AM',
      name: 'Ayesha Malik',
      username: '@ayesha',
      headline: 'Win-win for everyone!',
      rating: 5,
      date: 'Dec 8, 2024',
      story: 'Both my family and our distributor love this system. Clear communication, accurate records, and hassle-free payments. It is truly a win-win solution for everyone involved.',
      bgColor: '#e0f2f1',
      position: { bottom: '20%', left: '12%' }
    },
    {
      id: 7,
      initials: 'BH',
      name: 'Bilal Hassan',
      username: '@bilal',
      headline: 'Exceptional service quality!',
      rating: 5,
      date: 'Dec 22, 2024',
      story: 'The customer support team is amazing! They helped me set up everything within minutes. The platform is intuitive and has made my daily operations so much smoother.',
      bgColor: '#e1f5fe',
      position: { top: '60%', left: '45%' }
    },
    {
      id: 8,
      initials: 'ZT',
      name: 'Zainab Tariq',
      username: '@zainab',
      headline: 'Highly recommended!',
      rating: 5,
      date: 'Dec 5, 2024',
      story: 'I have recommended MilkFlow to all my friends and family. The transparency and ease of use are unmatched. Finally, a system that works for both customers and distributors!',
      bgColor: '#fff9c4',
      position: { bottom: '15%', right: '35%' }
    }
  ];

  const handleFlagClick = (testimonial) => {
    setActiveTestimonial(testimonial);
  };

  const handleCloseModal = () => {
    setActiveTestimonial(null);
  };

  const renderStars = (rating) => {
    return [...Array(rating)].map((_, index) => (
      <Star key={index} size={14} fill="#ffc107" color="#ffc107" />
    ));
  };

  return (
    <section className="testimonials-section">
      
      {/* Wavy Background Layers */}
      <div className="testimonials-bg-waves">
        <svg className="bg-wave wave-1" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path fill="rgba(62, 150, 231, 0.04)" d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,90.7C672,85,768,107,864,112C960,117,1056,107,1152,90.7C1248,75,1344,53,1392,42.7L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
        <svg className="bg-wave wave-2" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path fill="rgba(76, 175, 80, 0.03)" d="M0,192L48,197.3C96,203,192,213,288,202.7C384,192,480,160,576,154.7C672,149,768,171,864,186.7C960,203,1056,213,1152,208C1248,203,1344,181,1392,170.7L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>

      {/* Floating Milk Bottles Decoration */}
      <div className="testimonials-floating-elements">
        <div className="float-milk milk-1">🥛</div>
        <div className="float-milk milk-2">🥛</div>
        <div className="float-milk milk-3">🥛</div>
      </div>

      <Container>
        
        {/* Section Header */}
        <Row>
          <Col lg={6} md={12}>
            <div className="testimonials-header">
              <div className="clients-badge">25K+ Happy Clients</div>
              <h2 className="testimonials-title">
                Client <span className="title-highlight">Experiences</span>
              </h2>
            </div>
          </Col>
          <Col lg={6} md={12} className="d-flex align-items-center justify-content-lg-end">
            <button className="read-all-btn">
              Read All Reviews
              <ArrowRight size={18} className="ms-2" />
            </button>
          </Col>
        </Row>

        {/* Floating Testimonial Flags */}
        <div className="testimonials-canvas">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="testimonial-flag"
              style={{
                ...testimonial.position,
                backgroundColor: testimonial.bgColor,
                animationDelay: `${index * 0.3}s`
              }}
              onClick={() => handleFlagClick(testimonial)}
            >
              <div className="flag-avatar">
                {testimonial.initials}
              </div>
              <div className="flag-content">
                <h4 className="flag-headline">{testimonial.headline}</h4>
                <p className="flag-username">{testimonial.username}</p>
                <div className="flag-stars">
                  {renderStars(testimonial.rating)}
                </div>
              </div>
            </div>
          ))}
        </div>

      </Container>

      {/* Testimonial Modal/Popup */}
      {activeTestimonial && (
        <div className="testimonial-modal-overlay" onClick={handleCloseModal}>
          <div 
            className="testimonial-modal"
            onClick={(e) => e.stopPropagation()}
            style={{ borderTop: `4px solid ${activeTestimonial.bgColor}` }}
          >
            <button className="modal-close-btn" onClick={handleCloseModal}>
              <X size={24} />
            </button>

            <div className="modal-header-section">
              <div 
                className="modal-avatar"
                style={{ backgroundColor: activeTestimonial.bgColor }}
              >
                {activeTestimonial.initials}
              </div>
              <div className="modal-user-info">
                <h3 className="modal-name">{activeTestimonial.name}</h3>
                <p className="modal-username">{activeTestimonial.username}</p>
              </div>
            </div>

            <div className="modal-rating">
              {renderStars(activeTestimonial.rating)}
              <span className="modal-date">{activeTestimonial.date}</span>
            </div>

            <h4 className="modal-headline">{activeTestimonial.headline}</h4>
            
            <p className="modal-story">{activeTestimonial.story}</p>

            <div className="modal-footer">
              <div className="verified-badge">
                ✓ Verified Customer
              </div>
            </div>
          </div>
        </div>
      )}

    </section>
  );
};

export default TestimonialsSection;